// extracted by mini-css-extract-plugin
export default {"content":"ContentContainer_content__cUyHY"};